// Экранный Code128 → SVG. Кодировка — в общем модуле barcode-svg (используется и печатью).
import { barcodeBars } from './barcode-svg';

export function Barcode({ value, height = 30 }: { value: string; height?: number }) {
  const { bars, total } = barcodeBars(value);
  return (
    <svg
      viewBox={`0 0 ${total} ${height}`}
      width={total * 1.4}
      height={height}
      preserveAspectRatio="none"
      role="img"
      aria-label={`штрихкод ${value}`}
    >
      <rect width={total} height={height} fill="#fff" />
      {bars.map((b, i) => (
        <rect key={i} x={b.x} y={0} width={b.w} height={height} fill="#000" />
      ))}
    </svg>
  );
}
